import { Text } from "shared/components/typography/TitleStyles";
import styled, { css } from "styled-components";

export const TabList = styled.ol`
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  padding-inline-start: 0;
  padding-inline-end: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  display: flex;
  flex-wrap: wrap;
`;

const TabItemCss = css<{ $disabled?: boolean }>`
  color: ${({ theme }) => theme.colorTextMain};
  cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
  display: inline-block;
  list-style: none;
  padding: 6px 12px;
  margin: 0.25rem 0.25rem 0 0.25rem;
  border-top-left-radius: 0.7rem;
  border-top-right-radius: 0.7rem;
  min-width: fit-content;
  max-width: fit-content;
`;

export const InActiveTab = styled.li<{
  $disabled?: boolean;
  $inModal?: boolean;
  $hoverBackground?: "base" | "main";
}>`
  ${TabItemCss};
  border-color: transparent;
  border-width: 1px 1px 0px 1px;
  display: flex;
  flex-direction: row;
  align-items: center;

  &:hover {
    filter: ${({ theme }) => theme.filterHover};
    background-color: ${({ theme, $hoverBackground }) =>
      $hoverBackground === "main"
        ? theme.colorBackgroundMain
        : theme.colorBackgroundBase};
  }
`;

export const InActiveTabMain = styled(InActiveTab).attrs({
  $hoverBackground: "main" as const,
})``;

export const ActiveTab = styled.li<{ $disabled?: boolean; $inModal?: boolean }>`
  ${TabItemCss};
  background-color: ${({ theme, $inModal }) =>
    $inModal ? theme.colorBackgroundSecondary : theme.colorBackgroundMain};
  border: 1px solid ${({ theme }) => theme.colorOutlineSecondary};
  border-bottom: 1px solid transparent;
  margin-bottom: -1px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: default;
  gap: 4px;
`;

export const CloseTabs = styled.li<{ $disabled?: boolean }>`
  ${TabItemCss};
  background-color: transparent;
  border-radius: 99px;
  &:hover {
    background-color: ${({ theme }) => theme.colorBackgroundBase};
    filter: ${({ theme }) => theme.filterHover};
  }
`;

export const TabsContentWrapper = styled.div<{ $hideTabs: boolean }>`
  display: flex;
  justify-content: end;
  flex-direction: column;
  position: relative;
  z-index: 2; /* Tabs are 1px on top of content */
  visibility: ${({ $hideTabs }) => ($hideTabs ? "hidden" : "visible")};
`;

export const TabText = styled(Text)`
  display: flex;
  align-items: center;
  gap: 6px;
`;
